import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ProfileAccountComponent } from "./profile-account/profile-account.component";
import { ProfileSecurityPasswordDialog } from "./profile-security/@modals/profile-security-password-dialog/profile-security-password-dialog.component";
import { ProfileSecurityPincodeDialog } from "./profile-security/@modals/profile-security-pincode-dialog/profile-security-pincode-dialog.component";
import { ProfileSecurityComponent } from "./profile-security/profile-security.component";
import { ProfileComponent } from "./profile.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CluNumpadDialogModule } from "src/app/utils/clu-numpad-dialog/clu-numpad-dialog.module";
import { TranslateModule } from "@ngx-translate/core";
import { MaterialModule } from "src/app/material.module";
import { TablerIconsModule } from "angular-tabler-icons";
import * as TablerIcons from 'angular-tabler-icons/icons';
import { ProfileSecurityMfaConfigurationDialog } from "./profile-security/@modals/profile-security-mfa-configuration-dialog/profile-security-mfa-configuration-dialog.component";
import { CluBeSnackbarService } from "src/app/@clu-be/apps/@services/clube-snackbar.service";

@NgModule({
    declarations: [
        ProfileComponent,
        ProfileAccountComponent,
        ProfileSecurityComponent,
        ProfileSecurityPasswordDialog,
        ProfileSecurityPincodeDialog,
        ProfileSecurityMfaConfigurationDialog,
    ],
    imports: [
        CommonModule,
        MaterialModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        CluNumpadDialogModule,
        TablerIconsModule.pick(TablerIcons),
    ],
    providers: [
        CluBeSnackbarService
    ]
})
export class ProfileModule {}